import {
  parseTranslations,
  CommonTranslations,
  ASDRegistration,
  Sites
} from '@pdrj/pmi-iqos-shared-react'
import ASDRegistrationTranslations from './asd-registration.json'

ASDRegistration.componentTranslations = {
  ...ASDRegistrationTranslations,
  ...CommonTranslations
}

ASDRegistration.componentDefaultProps = {
  ...ASDRegistration.componentDefaultProps,
  translations: {
    ...parseTranslations(ASDRegistration.componentTranslations, true)
  },
  site: Sites.iqosphere
}

export default ASDRegistration
